module.exports = {
	"author": "Mapbox",
	"name": "mapbox.js",
	"description": "mapbox javascript api",
	"version": "2.4.0",
	"homepage": "http://mapbox.com/",
	"repository": {
		"type": "git",
		"url": "git://github.com/mapbox/mapbox.js.git"
	},
	"main": "src/index.js",
	"dependencies": {
		"corslite": "0.0.6",
		"isarray": "0.0.1",
		"leaflet": "0.7.7",
		"mustache": "2.2.1",
		"sanitize-caja": "0.1.3"
	},
	"scripts": {
		"test": "eslint --no-eslintrc -c .eslintrc src && mocha-phantomjs test/index.html"
	},
	"license": "BSD-3-Clause",
	"devDependencies": {
		"browserify": "^13.0.0",
		"clean-css": "~2.0.7",
		"eslint": "^0.23.0",
		"expect.js": "0.3.1",
		"happen": "0.1.3",
		"leaflet-fullscreen": "0.0.4",
		"leaflet-hash": "0.2.1",
		"marked": "~0.3.0",
		"minifyify": "^6.1.0",
		"minimist": "0.0.5",
		"mocha": "2.4.5",
		"mocha-phantomjs": "4.0.2",
		"sinon": "1.10.2"
	},
	"optionalDependencies": {},
	"engines": {
		"node": "*"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox.js/package.json
 ** module id = 944
 ** module chunks = 0 1 3 4 5 6
 **/